import * as z from 'zod';
import { BoardPositionEnum } from '../../Director/common';

export const keyPositionsSchema = z.object({
  [BoardPositionEnum.Manager]: z
    .string()
    .min(1, { message: 'Please select a manager' }),
  [BoardPositionEnum.Secretary]: z
    .string()
    .min(1, { message: 'Please select a secretary' }),
  [BoardPositionEnum.BankSignatory]: z
    .string()
    .min(1, { message: 'Please select a bank signatory' }),
  Director: z.string().min(1, { message: 'Please select a director' }),
});

export type TKeyPositionFieldTypes = z.infer<typeof keyPositionsSchema>;
